import { EllipsisTooltip } from '@src/components/common';
import { Tag } from 'antd';
import styled from 'styled-components';

export const StyledTag = styled(Tag)`
  font-size: 10px;
  line-height: unset;
  padding-inline: 3px;
  margin-inline-end: 3px;
`;

export const HintTagWrapper = styled.div<{ color: string }>`
  display: flex;
  color: ${(props) => `${props.color}`};
  border-radius: 3px;
  border: solid 1px ${(props) => `${props.color}`};
  padding: 0 3px;
  font-size: 10px;
  box-sizing: border-box;
  font-weight: 600;
`;

export const HintCellWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3px;
`;

export const StyledCell = styled.div`
  height: 100%;
  width: 100%;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: right;
`;

export const StyledEllipsis: any = styled.div`
  width: 100%;
  cursor: pointer;
  font-size: 14px;
  font-weight: 200;
  user-select: all;
  padding-top: 3px;
`;

export const StyledEllipsisTooltip = styled(EllipsisTooltip)`
  font-weight: 400;
  color: ${(props) => (props.selected ? '#0046ff' : 'unset')};
  align-self: center;
`;

export const ActionBar = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  background: #f4f4f4;
  margin-left: 5px;
`;

export const StyledRootCell = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;

  .action-bar {
    display: none;
  }

  &:hover {
    .action-bar {
      display: block;
    }
  }
`;
// removed hover color: #1c78db;
